const CANONICAL_PROFILE_FIELDS = {
  email: "Email",
  date_of_birth: "Date of birth",
  address: "Address",
};

const nonNegativeCount = (value) => {
  const number = Number(value);
  return Number.isInteger(number) && number >= 0 ? number : 0;
};

export const normalizeProfileSync = (value) => {
  const source = value && typeof value === "object" ? value : {};
  const rawFields = Array.isArray(source.fields)
    ? source.fields
    : Array.isArray(source.items)
      ? source.items
      : [];
  const fields = rawFields
    .filter((item) => item && Object.prototype.hasOwnProperty.call(CANONICAL_PROFILE_FIELDS, item.field))
    .map((item) => ({
      field: item.field,
      label: item.label || CANONICAL_PROFILE_FIELDS[item.field],
      status: String(item.status || "pending").toLowerCase(),
      submittedValue: item.submittedValue ?? item.submitted_value ?? item.proposed_value ?? "",
      currentValue: item.currentValue ?? item.current_value ?? item.original_value ?? "",
    }));
  const countedPending = fields.filter((field) => field.status === "pending" || field.status === "conflict").length;
  const countedApplied = fields.filter((field) => field.status === "applied").length;
  const countedRejected = fields.filter((field) => field.status === "rejected").length;

  return {
    revision: source.revision ?? source.version ?? "",
    fields,
    pendingCount: countedPending || nonNegativeCount(source.pending_count ?? source.pendingCount),
    appliedCount: countedApplied || nonNegativeCount(source.applied_count ?? source.appliedCount),
    rejectedCount: countedRejected || nonNegativeCount(source.rejected_count ?? source.rejectedCount),
  };
};

export const profileSyncBadge = (value) => {
  const sync = value && Array.isArray(value.fields) && Object.prototype.hasOwnProperty.call(value, "pendingCount")
    ? value
    : normalizeProfileSync(value);
  if (sync.pendingCount > 0) {
    return {
      label: `${sync.pendingCount} profile update${sync.pendingCount === 1 ? "" : "s"} pending`,
      tone: "warning",
    };
  }
  if (sync.appliedCount > 0) return { label: "Profile updated", tone: "success" };
  if (sync.rejectedCount > 0) return { label: "Existing profile kept", tone: "secondary" };
  return null;
};

export const profileSyncForSubmission = (submission) => normalizeProfileSync(
  submission?.profile_sync || submission?.profileSync || {},
);

